module.exports = __webpack_public_path__ + "static/img/cjx04.5726535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx04.png
// module id = 162
// module chunks = 0